export default {
      id: "oc-res-project-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-project",
      toString: function () {
        return this.url;
      }
    }